module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot3-cbf615a8c0ea552303a232465d111ef9.png";